/*
 * © 2026 eggs unimedia GmbH
 * Coded with love 💛
 */

import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'
import { Text, Card, WelcomeScreen } from './index'
import { useUser } from '../hooks/useUser'
import { getSchedules } from '../utils/scheduleUtils'

export const Home = () => {
  const { isLoggedIn, loading } = useUser()
  const [imageSrc, setImageSrc] = useState('./img/riesenrad.webp')
  const [schedules, setSchedules] = useState([])

  useEffect(() => {
    const element = document.getElementById('ohSoDirty')
    if (element && element.src) {
      setImageSrc(element.src)
    }
    
    // Load schedules for logged-in users
    if (isLoggedIn) {
      getSchedules().then(setSchedules)
    }
  }, [isLoggedIn])

  // Don't render anything while auth is being determined — prevents login flash
  if (loading) {
    return null
  }

  // Show WelcomeScreen for unauthenticated users
  if (!isLoggedIn) {
    return <WelcomeScreen />
  }

  // Logged in: Show upcoming event days
  return (
    <div
      className="min-h-[80vh] flex flex-col justify-center items-center bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${imageSrc})` }}
    >
      <div className="text-center px-4 w-full max-w-2xl">
        <Text type="Heading" variant="h1" className="mb-8 text-eggs-yellow !text-[48px] md:!text-[64px]">
          Willkommen zurück!
        </Text>
        <Text type="Body" variant="lg" className="text-gray-600 mb-8">
          Wähle einen Event-Tag:
        </Text>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {schedules.map((schedule) => (
            <Card key={schedule.slug} variant="outlined" className="hover:shadow-lg transition-all !rounded-[32px]">
              <NavLink
                to={`/${schedule.slug}`}
                className="block p-6 text-center"
              >
                <Text type="Heading" variant="h4" className="text-eggs-yellow mb-2">
                  {schedule.title}
                </Text>
                <Text type="Body" variant="sm" className="text-gray-600">
                  {schedule.date.toLocaleDateString('de-DE', { 
                    weekday: 'long', 
                    day: '2-digit', 
                    month: '2-digit' 
                  })}
                </Text>
              </NavLink>
            </Card>
          ))}
        </div>
      </div>
    </div>
  )
}
